import ExceptionIcon from '@jetbrains/icons/exception.svg?react'
import InfoIcon from '@jetbrains/icons/info.svg?react'
import WarningIcon from '@jetbrains/icons/warning.svg?react'
import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'
import classNames from 'classnames'
import {useMemo} from 'react'

import styles from './HealthItem.module.css'

type Props = {
  severity: 'Error' | 'Warning' | 'Info'
  className?: string
}

function HealthItemIcon({severity, className}: Props) {
  const isError = severity === 'Error'
  const isWarning = severity === 'Warning'
  const iconToShow = useMemo(() => {
    if (isError) {
      return ExceptionIcon
    }

    if (isWarning) {
      return WarningIcon
    }

    return InfoIcon
  }, [isError, isWarning])

  return <SvgIcon className={classNames(styles.icon, className)} icon={iconToShow} />
}

export default HealthItemIcon
